import React from 'react';
import { SubscribeToAddOnsFormV2 } from '@css-xp/base';

/**
 * This component is required to pass closeSidebar to the form. calling useSidebar
 * directly on the calling page causes continuous re-rendering
 * */
export const SubscribeToAddOnsSidebar = ({ ...props }: React.ComponentProps<typeof SubscribeToAddOnsFormV2>) => {
  return (
    <div>
      <SubscribeToAddOnsFormV2 {...props} />
    </div>
  );
};
